module.exports = __webpack_public_path__ + "static/fig-02-7ed6298ace170e939d813741c941b355.png";